import { useEffect, useRef } from 'react';
import { useStore } from './use-store';

/**
 * Одна фоновая отправка при входе в раздел с правом read основного slug.
 * Вызывается в родительском компоненте раздела, содержащем вложенные маршруты.
 * Переходы между подпутями не создают повторное посещение.
 */
export const useVisitStat = (section: string, canRead: boolean) => {
  const { dashboard } = useStore();
  const sentRef = useRef(false);

  useEffect(() => {
    sentRef.current = false;
  }, [section]);

  useEffect(() => {
    if (!canRead || sentRef.current) {
      return;
    }

    const sendVisit = () => {
      // Повторное получение прав и ошибка POST не запускают повторную отправку.
      sentRef.current = true;
      void dashboard.createVisitStat(section);
    };

    if (typeof window.requestIdleCallback === 'function') {
      const id = window.requestIdleCallback(sendVisit, { timeout: 2000 });

      return () => window.cancelIdleCallback(id);
    }

    // Освобождаем текущую задачу и в браузерах без requestIdleCallback.
    const id = window.setTimeout(sendVisit, 0);

    return () => window.clearTimeout(id);
  }, [dashboard, section, canRead]);
};
